import gsap, { random } from "gsap";
import Flip from "gsap/Flip";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import Loadeer from "loadeer";

gsap.registerPlugin(Flip, ScrollTrigger, ScrollToPlugin);

// --------------------------------------------------
// 🌄 Lazy Loading
// --------------------------------------------------

const loadeer = new Loadeer();
loadeer.observe();


// --------------------------------------------------
// 🔗 Menu
// --------------------------------------------------

const mamas = document.querySelectorAll('.menu_item.mama');
const header = document.querySelector('header');

let headerHeightAnimation = gsap.timeline({ paused: true });
headerHeightAnimation.to(header, {
  height: '3.5rem',
  duration: .25,
  ease: 'power1.inOut',
  onReverseComplete: function() { 
    gsap.set(header,{
      clearProps:'all'
    });
  }
});

headerHeightAnimation.reverse();

mamas.forEach(function (mama) {
  let mamaLink = mama.querySelector('a.menu_item_link');
  mamaLink.addEventListener('click', function (e) {
    mama.classList.toggle('is_open');
    headerHeightAnimation.reversed(!headerHeightAnimation.reversed());
    e.preventDefault();
  });
});

// --------------------------------------------------
// ☝️ Side Menu
// --------------------------------------------------

let progressPie = document.querySelector('.progress_pie');
ScrollTrigger.matchMedia({
  "(min-width: 1001px)": function() {
    if(progressPie) {
      gsap.to(progressPie, {
        autoAlpha: 0,
        ease: 'linear',
        scrollTrigger: {
          trigger: 'footer',
          scrub: .25,
          start: 'top bottom+=50',
          end: 'top bottom',
        },
      });
      return function() {
        gsap.set(progressPie, {
          clearProps: 'all'
        });
      }
    }
  }
}); 

// --------------------------------------------------
// 🪗 Drawers
// --------------------------------------------------

const drawers = document.querySelectorAll(".drawer");

drawers.forEach(function (drawer) {
  const drawer_content = drawer.querySelector(".drawer_content");
  const drawer_title = drawer.querySelector(".drawer_title");

  drawer_title.addEventListener("click", function (event) {
    if (gsap.getProperty(drawer_content, "display") === "none") {
      drawer.classList.add("is_active");
      gsap.set(drawer_content, {
        height: 0,
        opacity: 1,
        display: "block",
      });
      gsap.to(drawer_content, {
        height: "auto",
        duration: 0.5,
        ease: "power2.inOut",
        onComplete: function () {
          history.replaceState(null, null, drawer_title.getAttribute("href"));
        },
      });
    } else {
      drawer.classList.remove("is_active");
      gsap.to(drawer_content, {
        height: 0,
        opacity: 0,
        duration: 0.5,
        ease: "power2.inOut",
        onComplete: function () {
          gsap.set(drawer_content, {
            height: "auto",
            display: "none",
          });
          window.location.hash = "!";
        },
      });
    }
    event.preventDefault();
  });
});

// --------------------------------------------------
// ⏯ Custom controls for video and audio
// --------------------------------------------------

let mediaWraps = document.querySelectorAll(
  ".video_wrap:not(.gif_mode), .audio_wrap"
);

mediaWraps.forEach(function (mediaWrap) {
  let media = mediaWrap.querySelector("video, audio");
  let controls = mediaWrap.querySelector(".controls_wrap");
  let duration;
  let progress;

  // Handle seeking
  mediaWrap.addEventListener("click", function (event) {

    // Return if button is clicked or duration is not yet defined
    if (event.target.matches(".controls *") || !duration) return;

    // Seek to the clicked position
    if (
      mediaWrap.classList.contains("is_played") &&
      !event.target.matches(".video_inner, .video_inner *")
    ) {
      let percentagePosition = event.offsetX / controls.offsetWidth;
      media.currentTime = percentagePosition * duration;
    }

    // Play/pause
    else if (mediaWrap.classList.contains("is_playing")) {
      media.pause();
      mediaWrap.classList.remove("is_playing");
    } else {
      media.play();
      mediaWrap.classList.add("is_playing");
    }
  });

  // Time update function (called periodically while playing)
  media.addEventListener("timeupdate", function () {
    // Format time
    let minutes = Math.floor(media.currentTime / 60);
    minutes = ("0" + minutes).slice(-2);
    let seconds = Math.floor(media.currentTime % 60);
    seconds = ("0" + seconds).slice(-2);

    // Update progress time
    if (
      controls.querySelector(".progress span").innerHTML !==
      `${minutes}:${seconds}`
    ) {
      controls.querySelector(
        ".progress span"
      ).innerHTML = `${minutes}:${seconds}`;
    }

    // Add class to paused media
    if (media.paused) {
      mediaWrap.classList.remove("is_playing");
    } else {
      mediaWrap.classList.add("is_playing");
    }

    // Add class to muted media
    if (media.muted) {
      mediaWrap.classList.add("is_muted");
    } else {
      mediaWrap.classList.remove("is_muted");
    }
  });

  // Progress function (called every frame)
  function setProgress() {
    // If duration has been retrieved
    if (duration) {
      // Set progress variable to current time divided by duration
      progress = media.currentTime / duration;

      // Animate progress bar
      gsap.to(controls.querySelector(".progress"), {
        x: -100 + progress * 100 + "%",
        duration: 0.25,
      });
    }

    // Add class to played media
    if (progress > 0) {
      mediaWrap.classList.add("is_played");
    } else {
      mediaWrap.classList.remove("is_played");
    }

    // Handle progress time visiblity
    let progressPixels =
      controls.querySelector(".progress").offsetWidth * progress;
    if (progressPixels > 100 && controls.offsetWidth - progressPixels > 120) {
      gsap.to(controls.querySelector(".progress span"), {
        autoAlpha: 1,
      });
    } else {
      gsap.to(controls.querySelector(".progress span"), {
        autoAlpha: 0,
      });
    }

    // Call this function on the next frame
    requestAnimationFrame(function () {
      setProgress();
    });
  }

  setProgress();

  // Set duration after media has loaded
  media.addEventListener("loadedmetadata", function () {
    duration = media.duration;
    let minutes = Math.floor(duration / 60);
    minutes = ("0" + minutes).slice(-2);
    let seconds = Math.floor(duration % 60);
    seconds = ("0" + seconds).slice(-2);
    controls.querySelector(
      "button.duration span"
    ).innerHTML = `${minutes}:${seconds}`;
  });

  // Handle play/pause on play button
  let playButton = controls.querySelector("button.play");
  playButton.addEventListener("click", function () {
    if (media.paused) {
      media.play();
      mediaWrap.classList.add("is_playing");
    } else {
      media.pause();
      mediaWrap.classList.remove("is_playing");
    }
  });

  // Handle back button
  let backButton = controls.querySelector("button.back");
  backButton.addEventListener("click", function () {
    media.currentTime = 0;
  });

  // Handle mute button
  let muteButton = controls.querySelector("button.mute");
  muteButton.addEventListener("click", function () {
    if (media.muted) {
      media.muted = false;
      mediaWrap.classList.remove("is_muted");
    } else {
      media.muted = true;
      mediaWrap.classList.add("is_muted");
    }
  });

  // Handle fullscreen button
  let fullscreenButton = controls.querySelector("button.fullscreen");
  if (mediaWrap.requestFullscreen || mediaWrap.webkitRequestFullscreen) {
    fullscreenButton.addEventListener("click", function () {
      // Exit fullscreen if there's a fullscreen element
      if (document.fullscreenElement || document.webkitFullscreenElement) {
        // Modern browsers
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
        // Safari
        else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        }
      }
      // Request fullscreen if there's no fullscreen element
      else {
        // Modern browsers
        if (mediaWrap.requestFullscreen) {
          mediaWrap.requestFullscreen();
        }
        // Safari
        else if (mediaWrap.webkitRequestFullscreen) {
          mediaWrap.webkitRequestFullscreen();
        }
      }
    });
  } else {
    fullscreenButton.remove();
  }
});

// --------------------------------------------------
// 🎨 Layout Colors
// --------------------------------------------------

let colorBlocks = gsap.utils.toArray(".block_color[data-background_color], .block_color[data-text_color]");

if(colorBlocks.length) {
  window.addEventListener("load", function () {

    function animateColor(backgroundColor, textColor) {
      if (backgroundColor) {
        gsap.to(document.body, {
          "--background_color": backgroundColor,
          ease: "linear",
          duration: 0.25,
        });
      }
      if (textColor) {
        gsap.to(document.body, {
          "--color": textColor,
          ease: "linear",
          duration: 0.25,
        });
      }
    }
    
    colorBlocks.forEach(function (colorBlock, i) {
      let backgroundColor = colorBlock.dataset.background_color;
      let textColor = colorBlock.dataset.text_color;
    
      let prevBackgroundColor;
      let prevTextColor;
    
      if(colorBlocks[i - 1]) {
        prevBackgroundColor = colorBlocks[i - 1].dataset.background_color;
        prevTextColor = colorBlocks[i - 1].dataset.text_color;
      }
      else {
        prevBackgroundColor = gsap.getProperty(document.body, "--background_color");
        prevTextColor = gsap.getProperty(document.body, "--color");
      }
    
      ScrollTrigger.create({
        trigger: colorBlock,
        start: "top-=10 center",
        end: "top+=10 center",
        onEnter: () => {
          animateColor(backgroundColor, textColor);
        },
        onEnterBack: () => {
          animateColor(prevBackgroundColor, prevTextColor);
        },
      });
    });
  });
}

// --------------------------------------------------
// 🕑 Progress
// --------------------------------------------------

let sideMenu = document.querySelector(".side_menu");
if (sideMenu) {

  function updateScrollProgress() {
    const scrollHeight =
      document.documentElement.scrollHeight - window.innerHeight;
    const scrollPosition = window.pageYOffset;
    const scrollPercentage = (scrollPosition / scrollHeight) * 100;
    gsap.to(document.documentElement, {
      "--progress": scrollPercentage,
      duration: .5
    });
  }
  updateScrollProgress();
  window.addEventListener("scroll", updateScrollProgress);
  window.addEventListener("load", updateScrollProgress);

  document.querySelector(".side_menu").addEventListener('click', function() {
    if(window.innerWidth < 1000) {
      sideMenu.classList.toggle('is_open');
    }
  });

}

// --------------------------------------------------
// 📜 Smooth Scrolling
// --------------------------------------------------

let anchors = document.querySelectorAll('a[href^="#"]');
anchors.forEach(anchor => {
  if(!anchor.classList.contains('drawer_title') && !anchor.classList.contains('footnote_link') && !anchor.classList.contains('open') && !anchor.classList.contains('close')) {
    anchor.addEventListener("click", function (e) {
      let target = anchor.getAttribute("href");
      let targetElement = false;
      if(target != '#') {
        targetElement = document.querySelector(target);
      }
      if(targetElement) {
        gsap.to(window, {
          scrollTo: {
            y: targetElement,
            offsetY: 100,
          },
          ease: "power2.inOut",
          duration: 2,
        });
        history.replaceState(null, null, target);
        e.preventDefault();
      }
    });
  }
})

// --------------------------------------------------
// 📜 Scroll Menu
// --------------------------------------------------

if (sideMenu) {

  let anchors = gsap.utils.toArray("nav.anchors a.anchor");
  let activeAnchors = gsap.utils.toArray(".active_anchor");

  anchors.forEach(function (anchor) {
    let id = anchor.getAttribute("href");
    if (id != "#") {
      try {
        let anchorBlock = document.querySelector(id);
        if (anchorBlock) {
          anchor.addEventListener("click", function (e) {
            gsap.to(window, {
              scrollTo: {
                y: anchorBlock,
                offsetY: 100,
              },
              ease: "power2.inOut",
              duration: 2,
            });
            history.pushState(null, null, id);
            e.preventDefault();
          });
        }
      }
      catch(err) {
        console.log(err);
      }
    }
  });

  function activeChapter() {
    let activeAnchor = false;
    anchors.forEach(function (anchor) {
      let id = anchor.getAttribute("href");
      if (id != "#") {
        try {
          let anchorBlock = document.querySelector(id);
          if (anchorBlock) {
            if (
              anchorBlock.getBoundingClientRect().top <
              window.innerHeight / 2
            ) {
              activeAnchor = anchor;
            }
          }
        }
        catch(err) {
          console.log(err);
        }
      }
    });
    if (activeAnchor) {
      activeAnchors.forEach(function (anchor) {
        if (
          anchor.getAttribute("data-id") == activeAnchor.getAttribute("href")
        ) {
          anchor.classList.add("is_active");
        } else {
          anchor.classList.remove("is_active");
        }
      });
    } else {
      activeAnchors.forEach(function (anchor) {
        if (anchor.getAttribute("data-id") == "#") {
          anchor.classList.add("is_active");
        } else {
          anchor.classList.remove("is_active");
        }
      });
    }
  }

  activeChapter();
  window.addEventListener("scroll", activeChapter);
  window.addEventListener("load", activeChapter);
}

// --------------------------------------------------
// 🏠 Home Menu
// --------------------------------------------------

if(document.documentElement.classList.contains('t_home')) {

  let homeAnimation = gsap.timeline({
    paused: true,
    delay: .5,
    defaults: {
      duration: .75,
      ease: 'power2.inOut'
    }
  });
  homeAnimation.to('.home-menu__item--1', {
    height: () => gsap.getProperty('.home-menu__item--1', "--largeHeight", '%')
  });
  homeAnimation.to('.home-menu__item', {
    autoAlpha: 1,
  }, '-=.5');

  homeAnimation.call(function() {
    document.body.dispatchEvent(new Event('home-animation-complete'));
  });

  window.addEventListener('load', function() {
    homeAnimation.play();
  });

  let mamas = document.querySelectorAll('.home-menu__item--mama .home-menu__link');
  mamas.forEach(function(menuLink) {

    let mama = menuLink.closest('.home-menu__item--mama');

    let mamaAnimation = gsap.timeline({
      paused: true,
      defaults: {
        duration: .5,
        ease: 'power2.inOut'
      }
    });

    mamaAnimation.to(menuLink, {
      scaleY: .2,
      transformOrigin: 'top'
    }, 0);

    mamaAnimation.to(mama.querySelector('.home-submenu'), {
      scaleY: 1,
      autoAlpha: 1
    }, 0);

    mamaAnimation.to('.home-menu__item:not(.home-menu__item--mama)', {
      // autoAlpha: 0,
      yPercent: 250,
    }, 0);

    mamaAnimation.reverse();

    let reverseOnScroll = () => {
      ScrollTrigger.matchMedia({
        "(max-width: 1000px)": function() {
          mamaAnimation.reverse();
        }
      });
    }

    menuLink.addEventListener('click', function(e) {

      document.removeEventListener('scroll', reverseOnScroll)

      if(mamaAnimation.reversed()) {

        ScrollTrigger.matchMedia({
          "(min-width: 1001px)": function() {
            gsap.to(window, {
              scrollTo: 200,
              ease: "power2.inOut",
              duration: 1,
            });
          }
        });

        mamaAnimation.play()

        document.addEventListener('scroll', reverseOnScroll)

      }
      else {
        mamaAnimation.reverse()
      }

      e.preventDefault();
    });
    
  });

}

// --------------------------------------------------
// ♾️ Infinite Highlights
// --------------------------------------------------

let isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
let highlights = document.querySelector('.highlights');
if(window.innerWidth > 1001 && highlights) {

  let highlightsGroup = document.querySelector('.highlights__group');
  let highlightsClone = highlightsGroup.cloneNode(true);
  highlightsClone.classList.add('highlights__group--clone');
  highlights.appendChild(highlightsClone);

  let highlightsImages = highlights.querySelectorAll('img');
  highlightsImages.forEach(function(image) {
    loadeer.triggerLoad(image);
  });

  gsap.to('.highlights .card', {
    yPercent: () => 'random(-200, 200)',
    ease: 'none',
    scrollTrigger: {
      start: 0,
      end: ScrollTrigger.maxScroll(window) / 2,
      scrub: true,
      invalidateOnRefresh: true
    }
  });

  function setRandomColumns() {
    let columns = [1, 2, 3, 4];
    gsap.utils.toArray('.highlights .card').forEach(card => {
      let column = columns[Math.floor(Math.random() * columns.length)];
      columns = columns.filter(c => c !== column);
      gsap.set(card, {
        'grid-column': column,
      })
    });
  }

  // ScrollTrigger.normalizeScroll(true);

  document.body.addEventListener('home-animation-complete', function() {

    gsap.set(highlights, {
      autoAlpha: 1
    });
    gsap.fromTo(window, {
      scrollTo: 0
    }, {
      scrollTo: 200,
      ease: "power2.inOut",
      duration: 1,
      onComplete: () => {
        if(!isIOS) {
          ScrollTrigger.create({
            trigger: highlightsClone,
            start: 'top-=100 bottom-=50',
            end: 'top bottom-=150',
            invalidateOnRefresh: true,
            onEnter: self => {
              setRandomColumns();
              self.scroll(100);
              ScrollTrigger.refresh();
            },
          });
          ScrollTrigger.create({
            trigger: highlightsGroup,
            start: 'top top+=200',
            end: 'top+=100 top+=100',
            invalidateOnRefresh: true,
            onEnterBack: self => {
              setRandomColumns();
              self.scroll(ScrollTrigger.maxScroll(window) / 2 - window.innerHeight);
              ScrollTrigger.refresh();
            },
          });
        }
      }
    });
  });

}

// --------------------------------------------------
// 🗞️ Banner
// --------------------------------------------------

let banner = document.querySelector('.banner');
if(banner) {
  let bannerTL = gsap.timeline({
    repeat: -1
  });
  bannerTL.to('.banner__inner', {
    xPercent: -100,
    duration: 20,
    ease: 'none'
  })
  // Pause timeline while hovering over banner
  banner.addEventListener('mouseenter', function() {
    gsap.to(bannerTL, {
      timeScale: 0,
    })
  });
  banner.addEventListener('mouseleave', function() {
    gsap.to(bannerTL, {
      timeScale: 1,
    })
  });

  ScrollTrigger.matchMedia({
    "(max-width: 1000px)": function() {
      gsap.to('header:not(.t_home header)', {
        y: -33,
        scrollTrigger: {
          trigger: banner,
          start: 0,
          end: 100,
          scrub: .25,
        }
      });
    }
  });

}

// --------------------------------------------------
// 🦶 Footnotes
// --------------------------------------------------

let footnoteLinks = document.querySelectorAll('.footnote_link');
footnoteLinks.forEach(function(footnoteLink) {
  let footnoteWrap = document.getElementById(footnoteLink.getAttribute('href').substring(1));
  if(footnoteWrap) {
    let footnote = footnoteWrap.querySelector('.footnote');
    let close = footnoteWrap.querySelector('.footnote_close');
    footnoteLink.addEventListener('click', function(e) {
      gsap.to(footnoteWrap, {
        autoAlpha: 1,
        duration: .5
      });
      let state = Flip.getState(footnote);
      Flip.fit(footnote, footnoteLink, {
        scale: true,
        absolute: true
      });
      Flip.to(state, {
        duration: .5,
        scale: true,
        absolute: true,
        ease: 'power2.inOut',
        onComplete: () => {
          gsap.set(footnote, {
            clearProps: 'all'
          })
        }
      });
      history.replaceState(null, null, footnoteLink.getAttribute("href"));
      e.preventDefault();
    });
    close.addEventListener('click', function(e) {
      gsap.to(footnoteWrap, {
        autoAlpha: 0,
        duration: .5
      });
      let state = Flip.getState(footnote);
      Flip.fit(footnote, footnoteLink, {
        scale: true,
        absolute: true
      });
      Flip.from(state, {
        duration: .5,
        scale: true,
        absolute: true,
        ease: 'power2.inOut',
        onComplete: () => {
          gsap.set(footnote, {
            clearProps: 'all'
          })
        }
      });
      history.replaceState(null, null, close.getAttribute("href"));
      e.preventDefault();
    });
  }
});

// --------------------------------------------------
// 💠 Galleries
// --------------------------------------------------

let galleries = document.querySelectorAll('.block_image--multiple');
galleries.forEach(gallery => {

  let galleryImages = gallery.querySelectorAll('.image');
  let figcaption = gallery.querySelector('.figcaption');
  let viewport = gallery.querySelector('.block_image__viewport');
  let cursor = gallery.querySelector('.cursor');

  // Cursor positioning

  const xSet = gsap.quickSetter(cursor, "x", "px");
  const ySet = gsap.quickSetter(cursor, "y", "px");

  cursor.isRotating = false;
  cursor.direction = 'right';

  viewport.addEventListener("pointermove", (e) => {

    if(!cursor.isRotating) {
      const targetWidth = gallery.offsetWidth;
      const xCoordInTarget = e.clientX - gallery.getBoundingClientRect().left;
      if (targetWidth / 2 > xCoordInTarget) {
        if(cursor.direction == 'right') {
          cursor.isRotating = true;
          cursor.direction = 'left';
          gsap.to(cursor, {
            rotation: '-180_cw',
            duration: .25,
            ease: 'power1.out',
            onComplete: () => {
              cursor.isRotating = false;
            }
          });
        }
      } else {
        if(cursor.direction == 'left') {
          cursor.isRotating = true;
          cursor.direction = 'right';
          gsap.to(cursor, {
            rotation: '0_cw',
            duration: .25,
            ease: 'power1.out',
            onComplete: () => {
              cursor.isRotating = false;
            }
          });
        }
      }
    }

    if (e.pointerType == "touch") {
      gsap.set(cursor, {
        autoAlpha: 0
      });
    } else {
      gsap.set(cursor, {
        autoAlpha: 1
      });
      xSet(e.x);
      ySet(e.y);
    }
  });

  viewport.addEventListener("mouseleave", function () {
    gsap.set(cursor, {
      autoAlpha: 0
    });
  });



  galleryImages.forEach(function(image) {
    let dot = document.createElement('div');
    dot.classList.add('dot');
    figcaption.appendChild(dot);

    dot.addEventListener('click', () => {
      gsap.to(viewport, {
        scrollTo: image,
        duration: 1,
        ease: 'power2.inOut'
      })
    })

    image.addEventListener('mousedown', e => {

      if(!gsap.isTweening(viewport)) {

        gsap.timeline()
        .to(cursor, {
          scale: .9,
          duration: .1,
          ease: 'power1.out'
        })
        .to(cursor, {
          scale: 1,
          duration: .1,
          ease: 'power1.out'
        })

        const targetWidth = image.offsetWidth;
        const xCoordInTarget = e.clientX - image.getBoundingClientRect().left;
        if (targetWidth / 2 > xCoordInTarget) {
          // clicked left
          gsap.to(viewport, {
            scrollTo: image.previousElementSibling || viewport.lastElementChild,
            duration: 1,
            ease: 'power2.inOut'
          })
        } else {
          // clicked right
          gsap.to(viewport, {
            scrollTo: image.nextElementSibling || viewport.firstElementChild,
            duration: 1,
            ease: 'power2.inOut'
          })
        }
      }

    })

    ScrollTrigger.create({
      trigger: image,
      start: 'left center',
      end: 'right center',
      onToggle: function(self) {
        if(self.isActive) {
          dot.classList.add('active');
        }
        else {
          dot.classList.remove('active');
        }
      },
      horizontal: true,
      scroller: viewport,
    })

  })

})

// --------------------------------------------------
// 🗣️ Quotes
// --------------------------------------------------

// let quotes = document.querySelectorAll('.quote');
// quotes.forEach(function(quote) {

//   let entranceBlock;
//   if(quote.dataset.entrance) {
//     entranceBlock = document.getElementById(quote.dataset.entrance);
//   }
//   let exitBlock;
//   if(quote.dataset.exit) {
//     exitBlock = document.getElementById(quote.dataset.exit);
//   }

//   if(entranceBlock) {
//     gsap.fromTo(quote, {
//       autoAlpha: 0
//     }, {
//       immediateRender: false,
//       duration: 1,
//       autoAlpha: 1,
//       scrollTrigger: {
//         start: 'top top',
//         end: 'top top',
//         trigger: entranceBlock,
//         toggleActions: "play none reverse none",
//       }
//     })
//   }
//   else {
//     gsap.fromTo(quote, {
//       autoAlpha: 0
//     }, {
//       immediateRender: false,
//       duration: 1,
//       autoAlpha: 1
//     })
//   }

//   if(exitBlock) {
//     gsap.fromTo(quote, {
//       autoAlpha: 1
//     }, {
//       immediateRender: false,
//       duration: 1,
//       autoAlpha: 0,
//       scrollTrigger: {
//         trigger: exitBlock,
//         start: 'top top',
//         end: 'top top',
//         toggleActions: "play none reverse none",
//       }
//     })
//   }

// });

// --------------------------------------------------
// 🛒 Shopify Button Consent
// --------------------------------------------------

let shopifyBuyButtons = document.querySelectorAll('.shopify-buy-button');
if(shopifyBuyButtons.length > 0) {

  function getCookieValue(a) {
    const b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
  }

  function enableShopify() {
    shopifyBuyButtons.forEach(shopifyBuyButton => {
      let script = shopifyBuyButton.nextElementSibling;
      var newScript = document.createElement("script");
      newScript.setAttribute("type", "text/javascript");
      newScript.text = script.innerHTML;
      document.body.appendChild(newScript);
    })
  }

  if(getCookieValue('consent') == 'accepted') {
    enableShopify();
  }
  else {
    let consentWrap = document.createElement('div');
    consentWrap.classList.add('consent__wrap');
    consentWrap.innerHTML = `
    <div class="consent">
      <div class="consent__text text_wrap">
        <p>
          Damit du diesen Bereich von PRÄPOSITION besuchen kannst, benötigen wir dein Einverständnis zu unseren Cookies. Nur durch diese ist es möglich, unseren Shop hier einzubinden. Auch erheben wir, solltest du etwas bestellen wollen, personen­bezogene Daten. Genaueres kannst du in unserer <a href="https://www.praeposition.com/datenschutz">Datenschutz­erklärung</a> nachlesen. Sofern du hiermit nicht einverstanden bist, müssen wir dich leider auf unsere Startseite weiterleiten.
        </p>
      </div>
      <div class="consent__buttons">
        <button class="consent-button consent-button__accept">Einverstanden</button>
        <button class="consent-button consent-button__reject">Nicht einverstanden</button>
      </div>
    </div>
    `;
    document.body.appendChild(consentWrap);
    let consent = consentWrap.querySelector('.consent');
    let consentButtonAccept = consentWrap.querySelector('.consent-button__accept');
    let consentButtonReject = consentWrap.querySelector('.consent-button__reject');
    gsap.set(consent, {
      scale: .95,
      autoAlpha: 0
    })
    gsap.timeline()
    .to(consentWrap, {
      autoAlpha: 1,
      ease: 'none',
      duration: 2
    })
    .to(consent, {
      autoAlpha: 1,
      scale: 1,
      ease: 'power1.inOut',
    })

    consentWrap.addEventListener('click', e => {
      if(e.target == consentWrap) {
        gsap.timeline()
        .to(consentButtonAccept, {
          rotate: -4,
          scale: 1.1,
          ease: 'power1.inOut',
          duration: .2,
        })
        .to(consentButtonAccept, {
          rotate: 3,
          ease: 'power1.inOut',
          duration: .2,
        })
        .to(consentButtonAccept, {
          rotate: -2,
          ease: 'power1.inOut',
          duration: .2,
        })
        .to(consentButtonAccept, {
          rotate: 0,
          ease: 'power1.inOut',
          duration: .2,
        })
        .to(consentButtonAccept, {
          scale: 1,
          ease: 'power1.inOut',
          duration: .5,
        }, '-=.1')
      }
    })

    consentButtonAccept.addEventListener('click', () => {
      gsap.timeline()
      .to(consent, {
        autoAlpha: 0,
        scale: .95,
        ease: 'power1.out',
        duration: .25
      })
      .to(consentWrap, {
        autoAlpha: 0,
        ease: 'power1.inOut',
        onComplete: () => {
          consentWrap.remove();
          enableShopify();
        }
      })
      document.cookie = "consent=accepted; max-age=86400";
    })
    consentButtonReject.addEventListener('click', () => {
      window.location.href = 'https://www.praeposition.com';
    })

  }

}